import React from "react"
import PropTypes from "prop-types"
import { get } from "lodash"

import { FormGroup, Radio, Panel } from "react-bootstrap"

import { getLeaderName } from "../../lib/TripTools"

import "./TripNamePicker.less"

const s = ({ children }) => (
  <span style={{textDecoration: "line-through"}}>
    {children}
  </span>
)
  
const pickerProps = {
  trip: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  config: PropTypes.string
}

const pickerDefaults = {
  config: "default",
  value: null,
}

const options = {
  "people.leader": "Nombre del líder del grupo",
  officialName: "Nombre oficial",
  realName: "Apodo en pinyin",
  name: "Apodo en Chino",
}

const TNPConfig = {
  default: [ "people.leader", "officialName", "realName", "name" ],
  propuesta: [ "name", "realName", "people.leader", "officialName" ],
  vouchers: [ "people.leader", "realName", "name", "officialName" ],
  contrato: [ "officialName", "people.leader", "realName", "name" ]
}

export const TripNamePicker = ({ trip, value, onChange, config }) => (
  <Panel>
    
    <Panel.Heading>Elige qué nombre usar en el documento</Panel.Heading>
      
    <Panel.Body>
      <FormGroup className="name-picker">
        {
          TNPConfig[config]
            .map(key => ({
              key, 
              name: (
                key == "people.leader" 
                  ? getLeaderName(trip) 
                  : get(trip, key, null)
              )
            }))
            .map(({ key, name }, i) => {
              if (!name) {
                return (
                  <Radio checked={key == value} name="name-picker" key={key} value={key} disabled>
                    <s>{options[key]}</s>
                    { i == 0 && (<div className="rec-label">👌 Recomendado</div>) }
                  </Radio>
                )
              }
              else {
                return (
                  <Radio name="name-picker" key={key} value={key} onChange={() => onChange(key, name)}>
                    <b>{options[key]}: {name}</b>
                    { i == 0 && (<div className="rec-label">👌 Recomendado</div>) }
                  </Radio>
                )
              }
            })
        }
      </FormGroup>
    </Panel.Body>

  </Panel>
)

TripNamePicker.propTypes = pickerProps
TripNamePicker.defaultProps = pickerDefaults

export default TripNamePicker 
